
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"11.245","height":"11.245","viewBox":"0 0 11.245 11.245"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"id":"hidden","d":"M11.116,10.5,8.842,8.22a7.481,7.481,0,0,0,2.346-2.382.439.439,0,0,0,0-.433A6.728,6.728,0,0,0,5.623,2.079a5.911,5.911,0,0,0-2.408.514L.75.129A.439.439,0,0,0,.129.75L2.4,3.025A7.482,7.482,0,0,0,.057,5.406a.439.439,0,0,0,0,.433A6.728,6.728,0,0,0,5.623,9.166a5.912,5.912,0,0,0,2.409-.514L10.5,11.116a.439.439,0,0,0,.621-.621ZM5.623,8.288A5.741,5.741,0,0,1,.961,5.622,6.718,6.718,0,0,1,3.044,3.665l.826.826A2.085,2.085,0,0,0,6.754,7.375l.6.6A4.982,4.982,0,0,1,5.623,8.288Zm.485-1.559A1.207,1.207,0,0,1,4.517,5.138Zm-.97-2.212A1.207,1.207,0,0,1,6.729,6.107ZM7.375,6.754A2.085,2.085,0,0,0,4.491,3.87l-.6-.6a4.982,4.982,0,0,1,1.735-.309,5.741,5.741,0,0,1,4.662,2.666A6.718,6.718,0,0,1,8.2,7.58Zm0,0","fill":"currentColor"}})])
          )
        }
      }
    